export default __webpack_public_path__ + "3459eec864b7ca7f95c7c73ceef58b25.png";